/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { IconButton, InputBase, TextField, Typography, Button, Switch } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import PageLayout from '../../Components/PageLayout';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
// import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
// import { ReactComponent as CopyIcon } from "../../Assets/svg/CopyIcon.svg";
// import { ReactComponent as ContactIcon } from "../../Assets/svg/ContactIcon.svg";
import { ReactComponent as CityIcon } from "../../Assets/svg/CityIcon.svg";
// import { ReactComponent as HomeIcon } from "../../Assets/svg/HomeIcon.svg";
// import { ReactComponent as InfrainstractureIcon } from "../../Assets/svg/InfrainstractureIcon.svg";
// import { ReactComponent as RoomsIcon } from "../../Assets/svg/RoomsIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as MapMarkerIcon } from "../../Assets/svg/MapMarkerIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as SreachIcon } from "../../Assets/svg/SreachIcon.svg";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
// import { PropertyContext } from '../../context/property-context';
import data from '../../api/melkData.json';
// import Alert from '@mui/material/Alert';
// import Collapse from '@mui/material/Collapse';
// import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import { NumericFormat } from 'react-number-format';
import {
    useParams
} from "react-router-dom";
import { TileLayer, useMapEvents, Marker, Popup, MapContainer } from 'react-leaflet'
import { useSnackbar } from 'notistack';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
import ButtonNavigation from '../../Components/ButtonNavigation';
import DmandAdaptItem from '../../Components/DmandAdaptItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SettingIcon } from "../../Assets/svg/SettingIcon.svg";
import { useSearchDemandStore } from '../../store/searchDemand';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import useForceUpdate from 'use-force-update';
import { useUserStore } from '../../store/user';
import moment from "moment-jalaali"
import { ReactComponent as DownloadIcon } from "../../Assets/svg/DownloadIcon.svg";
import { ReactComponent as PersonList } from "../../Assets/svg/PersonList.svg";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import { priceItems, meterItems, dateTypes } from "../../api/ListData"
import { scrollingDiv } from '../../Components/ScrollRightToLeftDrag'
import Cookies from 'js-cookie'
import { InView } from 'react-intersection-observer';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        className: 'tab-btn',
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};






function AdaptProperty(props) {

    const { enqueueSnackbar } = useSnackbar();

    let { id, row } = useParams()

    const [tabValue, setTabValue] = React.useState(0);

    const [areasItems, setAreasItems] = React.useState([]);
    const [inPlusing, setInPlusing] = React.useState(true);

    const [moreModal, setMoreModal] = React.useState(false);


    const [showMeterItem, setShowMeterItem] = React.useState(1);

    const [nowDate, setNowDate] = React.useState("");
    const [yearDates, setYearDates] = React.useState([]);

    const [openSearchTypeModal, setOpenSearchTypeModal] = React.useState(false);

    const [showSearchType, setShowSearchType] = React.useState('');
    const [changeFlag, setChangeFlag] = React.useState(false);

    const [hasMore, setHasMore] = React.useState(true);
    const [propLoading, setPropLoading] = React.useState(false);
    const [ofsset, setOfsset] = React.useState(0);
    const dataFetchedRef = useRef(false);
    const [adapts, setAdapts] = React.useState([]);
    const [propKey, setPropKey] = React.useState(0);

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const locationId = useUserStore((state) => state.locationId)

    const navigation = useNavigate();
    const forceUpdate = useForceUpdate();

    const searchData = useSearchDemandStore((state) => state.searchData)
    const setSearchData = useSearchDemandStore((state) => state.setSearchData)
    const emptySearchData = useSearchDemandStore((state) => state.emptySearchData)

    const searchType = searchData.SearchType
    const limit = 10


    const handleClickSearchTypeModal = () => {
        setOpenSearchTypeModal(true);
    };



    const handleClickOpenZoneModal = () => {
        setOpenZoneModal(true);
        setTimeout(function () {
            if (document && typeof document.getElementById("areas-container") !== 'undefined' && document.getElementById("areas-container") !== null && areasItems.length > 0) {
                document.getElementById("areas-container").addEventListener('scroll', areaOnScroll)
                return () => document.getElementById("areas-container").removeEventListener('scroll', areaOnScroll)
            }
        }, 500)
    };



    const handleClickRentPriceModal = () => {
        setRentPriceModal(true);
    };



    const handleClickSalePriceModal = () => {
        setSalePriceModal(true);
        setShowMeterItem(1)
    };



    const handleClickMoreModal = () => {
        setMoreModal(true);
        var searchTmp = searchType
        emptySearchData()
        setSearchData({ name: "SearchType", value: searchTmp });
        scrollingDiv()

        setTimeout(function () { document.getElementById("floorNo-container").scroll(650, 0) }, 500)
    }


    const handleTabChange = (event, newValue) => {
        console.log("newValue", newValue)
        setTabValue(newValue);
    };



    useEffect(() => {
        const date = new Date()
        const fullDate = `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
        const format = "YYYY"
        let object = { fullDate, format }
        const now = new DateObject(object).convert(persian, persian_en).format()
        setNowDate(now)
        for (let i = parseInt(now); i >= parseInt(now) - 51; i--) {

            const tmp = yearDates
            tmp.push(i)
            setYearDates(tmp)
        }

        console.log("date", moment().format('YYYY-M-D'))
        var d = new Date(moment().format('YYYY-M-D'))

    }, [])

    useEffect(() => {
        if (changeFlag) {
            getAdapt(true)
            console.log('run use efect')
        }
    }, [searchData])




    const getAdapt = (resetState = false) => {
        // console.log("searchDataaaa", searchData)
        if (resetState) {
            setAdapts([])
            console.log("reset", adapts)
            setPropKey(propKey => propKey++)
            setOfsset(0);
            setHasMore(true)
        }

        setPropLoading(true)

        try {
            http({
                // url of the api endpoint (can be changed)
                url: `/properties/${id}/adapt`,
                method: "POST",
                data: {
                    LocationId: Cookies.get('locationId'),
                    Limit: limit,
                    AgencyInfo: true,
                    AdaptDivar:0,
                    Ofsset: ofsset
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("propres", res);

                const tmpProp = [...adapts]
                if (res.data.Applicants.length > 0) {
                    if (!resetState) {
                        res.data.Applicants.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setAdapts(tmpProp)
                        console.log("resetState not")
                    }
                    else
                        setAdapts(res.data.Applicants)

                    console.log("proper", adapts)

                    setPropKey(propKey => propKey++)
                } else {
                    console.log("End")
                    setHasMore(false)
                    if (resetState) setAdapts([])

                }
                setTimeout(function () { setInPlusing(true) }, 1000)
                setPropLoading(false)
                setChangeFlag(false)
            });

        } catch (e) {
            console.error(e);
            setPropLoading(false)
            setChangeFlag(false)
        }


    }

    // const onScroll = () => {
    //     if (document.getElementById("dashboard-content")) {
    //         const scrollTop = document.getElementById("dashboard-content").scrollTop
    //         const scrollHeight = document.getElementById("dashboard-content").scrollHeight
    //         const clientHeight = document.getElementById("dashboard-content").clientHeight
    //         if (scrollTop + clientHeight >= scrollHeight && inPlusing) {
    //             setOfsset(ofsset => ofsset + limit);
    //             setInPlusing(false)
    //             // setSearchData({"name":"Offset","value":ofsset})
    //             console.log("ofsset", ofsset)
    //         }
    //     }
    // }

    // useEffect(() => {
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("dashboard-content") !== 'undefined' && document.getElementById("dashboard-content") !== null && adapts.length > 0) {
    //             document.getElementById("dashboard-content").addEventListener('scroll', onScroll)
    //             return () => document.getElementById("dashboard-content").removeEventListener('scroll', onScroll)
    //         }
    //     }, 500)
    // }, [adapts])

    const handlePlusOffset = (inView) =>{
        console.log("🚀 ~ handlePlusPropOffset ~ inView:", inView)
    
            if (inView && !propLoading && hasMore) {
                setOfsset(ofsset => ofsset + limit);
            }
        } 

    useEffect(() => {
        console.log("offset use")

        if (hasMore && adapts.length) {
            getAdapt()
        }
    }, [ofsset])


    useEffect(() => {

        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        // emptySearchData()



        getAdapt()


    }, [])


    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const handleDeletedProps = (id) => {
        let tmpProperties = [...adapts]
        // console.log("tmpProperties",tmpProperties,adapts)
        tmpProperties = tmpProperties.filter(item => item.Id != id)
        setAdapts(tmpProperties)
    }



    return (
        <>
            <PageLayout title={`تقاضا های منطبق با ملک ${row}`} key={propKey}>
                <Box id="dashboard-content" sx={{ pt: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="scrollable force tabs example"
                        className='tab-nav'
                        dir="rtl"

                    >
                        <Tab label="درصد انطباق" className='tab-nav-item' />
                        <Tab label="سایر گزینه ها" className='tab-nav-item' />

                    </Tabs>
                    <Box sx={{ px: 3, py: 1 }} >
                        {
                            adapts && adapts.length > 0 ?
                                adapts.map((item, index) => (
                                    <DmandAdaptItem key={index} propInfo={item} handleDeletedProps={handleDeletedProps} />
                                ))
                                : !propLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            propLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                        }
                        <InView
                        as='div'
                        onChange={(inView, entry) =>
                            handlePlusOffset(inView, entry)
                        }></InView>
                    </Box>
                </Box>
                <ButtonNavigation />

            </PageLayout>



        </>
    );
}

export default AdaptProperty;